/** Period keys must match server `whatsapp-server/src/api/w1/util/dashboard-period.js`. */
export const DASHBOARD_PERIODS = [
  { id: "7d", label: "Last 7 days" },
  { id: "30d", label: "Last 30 days" },
  { id: "3m", label: "Last 3 months" },
  { id: "6m", label: "Last 6 months" },
  { id: "1y", label: "Last year" },
];

export const DEFAULT_DASHBOARD_PERIOD = "7d";
